import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-block',
  templateUrl: './about-block.component.html',
  styleUrls: ['./about-block.component.css'],
})
export class AboutBlockComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
